export function useGetUserLogin() {
  return localStorage.getItem('access_token') ? true : false
}
